import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import classnames from "classnames";
import ReportInput from "../vip/v2/ReportInput";
import RadioGroup from "./RadioGroup";
import { qlist } from "./Survey2025G112Config";
const Survey2025G112 = () => {
  
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [roleName, setRoleName] = useState("");

  const { register, handleSubmit, errors, setError, clearErrors, watch, getValues } = useForm(); // initialise the hook
  const watchQuestion4 = watch("question4");

  const onSubmit = (data) => {
    //console.log(data);
    
    if (roleName === "") {
      setError("roleName", {
        type: "manual",
        message: "請先確認角色",
      });
    } else {
      axios
        .post("/api/events/survey2025g112", {
          ...data,
          roleName: roleName,
        })
        .then((res) => {
          //console.log(res.data);
          setSuccessMessage(res.data);
        })
        .catch((err) => {
          //console.log(err.response);
          if (err.response.status === 400) {
            for (const [key, value] of Object.entries(err.response.data)) {
              setError(key, {
                type: "manual",
                message: value,
              });
            }
          } else {
            setErrorMessage(err.response.data.message);
          }
        });
    }
  };

  const getRole = async () => {
    setRoleName("");
    clearErrors("roleId");
    clearErrors("roleName");

    const roleId = getValues("roleId");
    
    axios
        .get(`/api/events/survey2025g112_getrole?id=${roleId}`)
        .then((res) => {
          //console.log(res.data);
          if (res.data.result) {
            setRoleName(res.data.result);
          } else {
            setError("roleName", {
              type: "manual",
              message: "找不到角色資料。",
            });
          }
        })
        .catch((err) => {
          //console.log(err.response);
          if (err.response.status === 400 || err.response.status === 401) {
            setError("roleId", {
              type: "manual",
              message: err.response.data,
            });
          }
        });
  };

  const onRoleIdChange = () => {
    setRoleName("");
  };

  let qOption = [];

  qlist.map((q, i) => {
    let subArray = [];
    for (const [key, value] of Object.entries(q.answers)) {
      subArray.push({ label: value, value: key})
    }
    qOption[i] = subArray;
  });

  return (
    <div className="container">
        <div className="row">
          <div className="col-md-9 col-lg-7 m-auto">
              <TitlePart
                title={"《巔峰極速》官方LINE玩家問卷"}
                desc={`《巔峰極速》的玩家您好，感謝您參與本次龍邑遊戲調查，本次調查目的如下：
 1. 對玩家的使用者輪廓現狀進行分析
 2. 回訪部分使用者或邀請參與線下訪談、活動體驗
 💎車手完成下方問卷後，鑽石*100獎勵將於每日18:00發放至遊戲內信箱
 ⚠️每個角色限填一次，問卷資料如填寫錯誤，視同自動放棄領獎資格。
 `}
              />

            {!successMessage && (
              <form
                className="card border"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card border">
                  <div className="card-body">
                    <div className="card-text">
                      <div className="form-group col-md-9 m-auto">
                        <ReportInput
                          name="roleId"
                          label="角色ID"
                          symbol="🔢"
                          register={register({
                            pattern: {
                              value: /^\d{10}$/,
                              message: "請輸入10碼數字",
                            },
                            required: `請輸入角色ID`,
                          })}
                          placeholder="輸入角色ID"
                          error={errors.roleId}
                          onChange={roleName !== "" ? onRoleIdChange : null}
                          getRoleButton={getRole}
                        />
                      </div>
                      <div className="form-group col-md-9 m-auto">
                        <ReportInput
                          name="roleName"
                          label="角色名稱"
                          symbol="🦸"
                          error={errors.roleName}
                          defaultValue={roleName}
                          readonly={true}
                        />
                      </div>
                      <div className="form-group col-md-9 m-auto">
                        <ReportInput
                          name="email"
                          label="Email"
                          symbol="📧"
                          register={register({
                            required: "輸入您的電子郵件",
                            pattern: {
                              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                              message: "電子郵件格式不符合",
                            },
                          })}
                          error={errors.email}
                          placeholder="輸入電子郵件"
                        />
                      </div>
                      <div className="form-group col-md-9 m-auto">
                        <ReportInput
                          name="phone"
                          label="手機"
                          symbol="📱"
                          register={register({
                            required: "輸入您的手機號碼",
                            pattern: {
                              value: /^[0-9]/,
                              message: "請輸入數字",
                            },
                          })}
                          error={errors.phone}
                          placeholder="輸入手機號碼."
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border">
                  <div className="card-body">
                    <div className="card-text">
                      <div className="form-group col-md-9 m-auto">
                      <label htmlFor="question1" className="col-form-label">
                        {qlist[0].question}
                      </label>
                        <RadioGroup
                          name="question1"
                          register={register({
                            required: "請選擇答案",
                          })}
                          error={errors.question1}
                          options={qOption[0]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border">
                  <div className="card-body">
                    <div className="card-text">
                      <div className="form-group col-md-9 m-auto">
                      <label htmlFor="question2" className="col-form-label">
                        {qlist[1].question}
                      </label>
                        <RadioGroup
                          name="question2"
                          register={register({
                            required: "請選擇答案",
                          })}
                          error={errors.question2}
                          options={qOption[1]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border">
                  <div className="card-body">
                    <div className="card-text">
                      <div className="form-group col-md-9 m-auto">
                      <label htmlFor="question3" className="col-form-label">
                        {qlist[2].question}
                      </label>
                        <RadioGroup
                          name="question3"
                          register={register({
                            required: "請選擇答案",
                          })}
                          error={errors.question3}
                          options={qOption[2]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border">
                  <div className="card-body">
                    <div className="card-text">
                      <div className="form-group col-md-9 m-auto">
                      <label htmlFor="question4" className="col-form-label">
                        {qlist[3].question}
                      </label>
                        <RadioGroup
                          name="question4"
                          register={register({
                            required: "請選擇答案",
                          })}
                          error={errors.question4}
                          options={qOption[3]}
                        />
                        {watchQuestion4 === "f" && (
                          <span>
                          <input
                            type="text"
                            name="question4_other"
                            ref={register({
                              required: "請填寫其它商品",
                            })}
                            placeholder="請填寫其它商品"
                            maxLength="20"
                            className={classnames("form-control form-control-md", {
                              "is-invalid": errors.question4_other,
                            })}
                          />
        
                          {errors.question4_other && (
                            <div className="invalid-feedback">
                              {errors.question4_other?.message}
                            </div>
                          )}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border">
                  <div className="card-body">
                    <div className="card-text">
                    <div className="form-group col-md-9 m-auto">
                      {errorMessage && (
                        <div className="text-danger d-block">
                          {errorMessage}
                        </div>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary float-right"
                    >
                      送出問卷
                    </button>
                    </div>
                  </div>
                </div>
              </form>
              )}
              {successMessage && (
                <div className="card border alert-success m-5">
                  <div className="card-body">
                    <div className="card-text">
                      <div className="form-group col-md-9 m-auto">
                        
                          角色ID：{successMessage.roleId} <br />
                          感謝您參與本次問卷活動，獎勵將於每日18:00發放至遊戲內信箱
                        
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <TitlePart
                desc={`⚠️注意事項
 *本次調查涉及您透過問卷主動向我們提供的個人資訊，若您同意參與本次調查，則視同同意我們收集、處理這些個人資訊。
 *請不要填寫與問卷無關或是違法的相關內容。
 *若您是未成年的使用者，建議您在取得監護人同意的情況下參與本次調查活動。
 *本問卷為自願參加形式，您沒有強制參與的義務，如您對本次調查有任何疑慮，或不同意我們處理您的個人資訊，您有權隨時退出問卷調查。
 *如遇不可抗拒之因素，龍邑遊戲保有隨時修改活動辦法及獎項或中止本活動之權利。
 `}
              />
            </div>
          </div>
          
    </div>
  );
};

export default Survey2025G112;

const TitlePart = ({ title, desc }) => {
  return (
    <div
      className="card m-1"
      style={{ lineHeight: "32px", whiteSpace: "pre-line" }}
    >
      <div className="card-body">
        <div className="card-title h4">{title}</div>
        <div className="card-text">{desc}</div>
      </div>
    </div>
  );
};
